import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import ContentContainer from "../common/ContentContainer";
import { useTranslation } from "react-i18next";
import { deleteQuery, fetchQuestions } from "../../actions/ai-action";
import { Col, Form, Row } from "react-bootstrap";
import useLoading from "../hooks/useLoading";
import Loading from "../common/Loading";
import { toast } from "react-toastify";
import BackButton from "../common/BackButton";
import CustomPagination from "../common/CustomPagination";
import { formatDateTime } from "../../utils/Utils";
import AiDisclaimer from "./AiDisclaimer";
import ReactStatePagination from "../common/ReactStatePagination";


const ArtificialIntelligenceSaved = (props) => {
  const {fetchQuestions,deleteQuery} = props
  const { t } = useTranslation()
  const newUserIntroPupup = useSelector((state) => state.settings.newUserIntroPupup);
  const [setLoading, bindLoading] = useLoading(false);
  const questions = useSelector((state)=>state.data.aiQuestions) || []
  const startItem = useSelector((state)=>state.data.aiQuestionsStart)
  const total = useSelector((state)=>state.data.aiQuestionsTotal)
  const itemsPerPage = 5
  const pageNum=1;
  useEffect(()=>{
    fetchQuestions("",itemsPerPage,pageNum)
  },[])
  //
  const toggleQa = (id) => {
    const collapsibleElement = document.getElementById(`graphCollapse${id}`);
    if (collapsibleElement) {
      collapsibleElement.classList.toggle("show");
    }
  };
  const deleteQa = (id)=>{
    deleteQuery(id).then((res)=>{
        toast.success("Success")
        fetchQuestions("",itemsPerPage,pageNum)
    }).catch((err)=>{
      toast.error("Error")
    })
  }
  const questionsRows = questions && questions.map((question,id)=>{
    return(
      <div className="ai-accordion-item-wrapper">
					<img src="/images/delete-icon.svg" alt="" onClick={()=>deleteQa(question.id)} className="pointer"/>
      <div className="accordion-item">
            <h2 className="accordion-header" id="headingOne">
              <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" onClick={()=>toggleQa(question.id)}>
                <img src="/images/icon-question.svg" alt=""/>
                <div>
                  <span>{formatDateTime(question.created_at)}</span>
                  <h4>{question.question}</h4>
                </div>
              </button>
            </h2>
            <div  className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample" id={`graphCollapse${question.id}`}>
              <div className="accordion-body">
                      <div dangerouslySetInnerHTML={{__html:question.answer}}></div>
                      <AiDisclaimer></AiDisclaimer>
              </div>
        </div>
      </div>
      </div>
      
    )
  })
  
  return (
    <ContentContainer url="artificial-intelligence" title={t("AI")} showExchange={true}>
      <Loading {...bindLoading}>
      <div className="ai-accrodion-area">
								<div className="accordion" id="accordionExample">
									{questionsRows}
								
								</div>
							</div>
              <div className="bottom-center">
              <CustomPagination
                    startItem={startItem}
                    onChange={fetchQuestions}
                    totalCount={total}
                    selectedTab={""}
                    itemsCountPerPage={itemsPerPage}
                  />
            </div>
     </Loading>
    </ContentContainer>
  );
};

export default connect(null,{fetchQuestions,deleteQuery})(ArtificialIntelligenceSaved);
